module.exports = __webpack_public_path__ + "img/introducePageEight_show_two.bc912e6e.png";